module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex align-items-center justify-content-start flex-wrap mt-5 add-image"
  }, [_c('div', {
    staticClass: "col-5"
  }, [_c('input', {
    class: ("img-downloader-" + (this.type)),
    attrs: {
      "type": "file",
      "multiple": "",
      "data-allowed-file-extensions": "jpg png jpeg"
    },
    on: {
      "change": function (e) { return _vm.selectImage(e, _vm.type); }
    }
  }), _vm._v(" "), (_vm.fileSelected) ? _c('div', {
    staticClass: "rotate-section"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/rotate-left.png",
      "alt": "rotate-left"
    },
    on: {
      "click": function($event) {
        _vm.rotateImg('left', _vm.type)
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/rotate-right.png",
      "alt": "rotate-right"
    },
    on: {
      "click": function($event) {
        _vm.rotateImg('right', _vm.type)
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-material col-5"
  }, [(_vm.type !== 'slider') ? _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": (_vm.type + "-name")
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("input.name")) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.type !== 'slider') ? _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": (_vm.type + "-name")
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function (e) { return _vm.handleLabelChange(_vm.type, e.target.value); }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save",
    attrs: {
      "type": "button",
      "disabled": _vm.disableAddImage
    },
    on: {
      "click": function($event) {
        _vm.addImage(_vm.type)
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("button.add")) + "\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d10e1886"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/rentals/detail/ImageUploader.vue
// module id = 1432
// module chunks = 0